import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCalendarChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M8.335 2.1c.394 0 .714.32.714.713v1.094h5.983V2.813a.713.713 0 1 1 1.427 0v1.094h2.625A2.616 2.616 0 0 1 21.7 6.523v12.461a2.616 2.616 0 0 1-2.616 2.616H4.816A2.616 2.616 0 0 1 2.2 18.984V6.524a2.616 2.616 0 0 1 2.616-2.617h2.806V2.813c0-.394.32-.713.713-.713Zm6.697 3.234H9.05v1.094a.713.713 0 1 1-1.427 0V5.334H4.816c-.657 0-1.19.532-1.19 1.19v1.54h16.647v-1.54c0-.658-.532-1.19-1.189-1.19H16.46v1.094a.713.713 0 0 1-1.427 0V5.334ZM3.627 9.491v9.493c0 .657.532 1.19 1.189 1.19h14.268c.657 0 1.19-.533 1.19-1.19V9.491H3.626Z"
    />
    <path
      fill="#F7A600"
      d="M18.136 11.62a.713.713 0 0 0-.713-.713l-3.514-.002a.713.713 0 1 0-.001 1.427h1.739l-2.94 2.765a.238.238 0 0 1-.304.019l-.781-.573a1.665 1.665 0 0 0-2.074.084l-3.95 3.418a.713.713 0 0 0 .933 1.08l3.951-3.42a.238.238 0 0 1 .296-.011l.782.572c.647.475 1.54.42 2.124-.13l3.024-2.843v1.841a.713.713 0 0 0 1.426.001l.002-3.514Z"
    />
  </svg>
);
export default SvgTwoColorCalendarChart;
